import request from "@/utils/request";

export function getAllMajors() {
  return request({
    url: "majors/all",
    method: "post",
  });
}

export function getAllAyinNamehCategories() {
  return request({
    url: "ayinnameh/getAllCategories",
    method: "post",
  });
}

export function getAyinNamehDetails(id) {
  return request({
    url: "ayinnameh/getAyinDetails",
    method: "post",
    data: { serial: id },
  });
}

export function downloadAttach(serial) {
  return request({
    url: "ayinnameh/downloadAttach",
    method: "post",
    data: { serial },
  });
}

export function getAllOstanCity() {
  return request({
    url: "schools/getAllOstanCity",
    method: "post",
  });
}
export function getAllSchools(citySerial = "", jensiatSerial = "") {
  return request({
    url: "schools/getAllSchools",
    method: "post",
    data: { citySerial, jensiatSerial },
  });
}

export function getSchoolInfo(schoolSerial) {
  return request({
    url: "schools/getSchoolInfo",
    method: "post",
    data: { schoolSerial },
  });
}

export function getSchoolPersonnel(schoolSerial) {
  return request({
    url: "schools/getAllPersonnel",
    method: "post",
    data: { schoolSerial },
  });
}

export function getSchoolTeachers(schoolSerial) {
  return request({
    url: "schools/getAllTeachers",
    method: "post",
    data: { schoolSerial },
  });
}

export function getSchoolPictures(schoolSerial) {
  return request({
    url: "schools/getSchoolPictures",
    method: "post",
    data: { schoolSerial },
  });
}
